function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import Player from '../../template/player.art';
import utils from './utils';
var Template = function () {
    function Template(options, player) {
        _classCallCheck(this, Template);
        this.container = options.container;
        this.options = options;
        this.player = player;
        options.theme && this.setTheme(options.theme);
        options.smallWindow && this.buildSmallWindow();
        options.isFireFox = utils.isFirefox;
        options.hasEcharts = !!window.echarts;
        options.hasAceEditor = !!window.ace;
        this.init(options);
        this.initHitokoto(options);
    }
    _createClass(Template, [
        {
            key: 'setTheme',
            value: function setTheme(color) {
                this.container.style.setProperty('--themeColor', color);
                this.container.style.setProperty('--themeColorLight', utils.colorLuminance(color, 0.3));
                this.container.style.setProperty('--themeColorDark', utils.colorLuminance(color, -0.3));
            }
        },
        {
            key: 'init',
            value: function init(options) {
                this.container.innerHTML = Player(options);
                var $ = this.container.querySelector.bind(this.container);
                var $all = this.container.querySelectorAll.bind(this.container);
                this.mask = $('.mfunsPlayer-mask');
                this.miniPlayer = $('.mfunsPlayer-miniPlayer');
                this.previewMask = $('.mfunsPlayer-preview-mask');
                this.canvas = $('.mfuns_canvas');
                this.video = $('.mfunsPlayer-video');
                this.videoMask = $('.mfunsPlayer-video-mask');
                this.videoWrap = $('.mfunsPlayer-video-wrap');
                this.activityMask = $('.mfunsPlayer-activity-mask');
                this.activity = $('.mfunsPlayer-activity');
                this.activityClose = $('.mfunsPlayer-activity-close');
                this.emit = $('.emit');
                this.fullButton = $('.mfunsPlayer-controller-fullButton');
                this.danmakuRoot = $('.mfunsPlayer-video-danmaku-root');
                this.menu = $('.mfunsPlayer-menu');
                this.menuItem = $all('.mfunsPlayer-menu-item');
                this.danmaku = $('.mfunsPlayer-danmaku');
                this.danmakuCount = $('.mfunsPlayer-video-danmaku-count');
                this.danmakuSource = $('.mfunsPlayer-video-danmaku-source');
                this.danmakuSource_mfuns = $('.mfunsPlayer-video-danmaku-source-item.mfuns');
                this.danmakuSource_bili = $('.mfunsPlayer-video-danmaku-source-item.bili');
                this.danmakuSource_acfun = $('.mfunsPlayer-video-danmaku-source-item.acfun');
                this.danmakuSource_unknown = $('.mfunsPlayer-video-danmaku-source-item.unknown');
                this.danmaku_btn = $('.mfunsPlayer-controller-danmaku-trigger');
                this.danmakuSettings_btn = $('.mfunsPlayer-controller-danmaku-settings');
                this.danmakuSettings_panel = $('.mfunsPlayer-danmaku-settings-mask');
                this.danmaku_filter_picker = $('.mfunsPlayer-danmaku-filter-picker');
                this.danmaku_opacity_slider = $('.mfunsPlayer-danmaku-opacity-slider');
                this.danmaku_opacity_value = $('.mfunsPlayer-danmaku-opacity-value');
                this.danmaku_showarea_slider = $('.mfunsPlayer-danmaku-showarea-slider');
                this.danmaku_showarea_value = $('.mfunsPlayer-danmaku-showarea-value');
                this.danmaku_size_slider = $('.mfunsPlayer-danmaku-size-slider');
                this.danmaku_size_value = $('.mfunsPlayer-danmaku-size-value');
                this.danmaku_speed_slider = $('.mfunsPlayer-danmaku-speed-slider');
                this.danmaku_speed_value = $('.mfunsPlayer-danmaku-speed-value');
                this.advancedDanmaku = $('.mfunsPlayer-advanced-danmaku');
                this.headBar = $('.mfunsPlayer-headBar');
                this.headTitle = $('.mfunsPlayer-headBar-title');
                this.barWrap = $('.mfunsPlayer-bar-wrap');
                this.bar = $('.mfunsPlayer-bar');
                this.playedBar = $('.mfunsPlayer-playedBar');
                this.bufferedBar = $('.mfunsPlayer-bufferedBar');
                this.thumb = $('.mfunsPlayer-thumb');
                this.barMark = $('.mfunsPlayer-bar-mark');
                this.barTime = $('.mfunsPlayer-barTime');
                this.barPreview = $('.mfunsPlayer-bar-preview');
                this.bezel = $('.mfunsPlayer-bezel');
                this.tipItem = $all('.mfunsPlayer-controller-tip');
                this.speedInfo = $('.mfunsPlayer-speed-info');
                this.speedItem = $all('.mfunsPlayer-speed-item');
                this.resolutionInfo = $('.mfunsPlayer-resolution-info');
                this.resolutionMask = $('.mfunsPlayer-resolution-mask');
                this.resolutionItem = $all('.mfunsPlayer-resolution-item');
                this.prev_btn = $('.mfunsPlayer-controller-prev');
                this.next_btn = $('.mfunsPlayer-controller-next');
                this.repeat_btn = $('.mfunsPlayer-controller-repeat');
                this.repeat_tip = $('.mfunsPlayer-controller-repeat .mfunsPlayer-controller-tip');
                this.pagelistItem = $all('.mfunsPlayer-pagelist-item');
                this.pageListLabel = $('.mfunsPlayer-controller-label.mfunsPlayer-pagelist-info');
                this.pagelist = $('.mfunsPlayer-pagelist-list');
                this.volume_btn = $('.mfunsPlayer-controller-volume');
                this.volumeMask = $('.mfunsPlayer-controller-volume-mask');
                this.volumeBarWrap = $('.mfunsPlayer-controller-volume-wrap');
                this.volumeBar = $('.mfunsPlayer-controller-volume-bar');
                this.volumeNum = $('.mfunsPlayer-controller-volume-num');
                this.volumePercentage = $('.mfunsPlayer-controller-volume-percentage');
                this.volumeIcon = $('.mfunsPlayer-controller-volume-icon');
                this.widescreen_btn = $('.mfunsPlayer-controller-widescreen');
                this.widescreen_tip = $('.mfunsPlayer-controller-widescreen .mfunsPlayer-controller-tip');
                this.webfull_btn = $('.mfunsPlayer-controller-webfull');
                this.webfull_tip = $('.mfunsPlayer-controller-webfull .mfunsPlayer-controller-tip');
                this.fullscreen_btn = $('.mfunsPlayer-controller-fullscreen');
                this.fullscreen_tip = $('.mfunsPlayer-controller-fullscreen .mfunsPlayer-controller-tip');
                this.browserFullButtonIcon = $('.mfunsPlayer-controller-full-icon');
                this.settings_btn = $('.mfunsPlayer-controller-settings');
                this.video_scale_picker = $('.mfunsPlayer-video-scale-picker');
                this.video_autoplay_switch = $('.mfunsPlayer-video-autoPlay-switch');
                this.video_nextpage_switch = $('.mfunsPlayer-video-nextpage-switch');
                this.video_autoSkip_switch = $('.mfunsPlayer-video-autoSkip-switch');
                this.video_smallWindow_switch = $('.mfunsPlayer-video-smallWindow-switch');
                this.video_borderhidden_switch = $('.mfunsPlayer-video-borderhidden-switch');
                this.video_darkmode_switch = $('.mfunsPlayer-video-darkmode-switch');
                this.video_mirror_switch = $('.mfunsPlayer-video-mirror-switch');
                this.video_color_mask = $('.mfunsPlayer-video-color-mask');
                this.video_color_close = $('.mfunsPlayer-video-color-close');
                this.video_brightness_slider = $('.mfunsPlayer-video-brightness-slider');
                this.video_brightness_value = $('.mfunsPlayer-video-brightness-value');
                this.video_contrast_slider = $('.mfunsPlayer-video-contrast-slider');
                this.video_contrast_value = $('.mfunsPlayer-video-contrast-value');
                this.video_saturate_slider = $('.mfunsPlayer-video-saturate-slider');
                this.video_saturate_value = $('.mfunsPlayer-video-saturate-value');
                this.video_color_reset = $('.mfunsPlayer-video-color-reset');
                this.video_filter_picker = $('.mfunsPlayer-video-filter-picker');
                this.player_info_close = $('.mfunsPlayer-player-info-close');
                this.player_info_mask = $('.mfunsPlayer-player-info-mask');
                this.player_info_version = $('.mfunsPlayer-player-info-version');
                this.range = $('.range');
                this.play_btn = $('.mfunsPlayer-controller-play');
                this.highEnergyBar = $('.mfunsPlayer-highEnergy-bar');
                this.controllerMask = $('.mfunsPlayer-controller-mask');
                this.controller = $('.mfunsPlayer-controller');
                this.controllerWrap = $('.mfunsPlayer-controller-wrap');
                this.footBar = $('.mfunsPlayer-footBar');
                this.footBarWrap = $('.mfunsPlayer-footBar-wrap');
                this.loading = $('.mfunsPlayer-loading-tip');
                this.loadingSpeed = $('.mfunsPlayer-loading-speed');
                this.hitokoto = $('.mfunsPlayer-loading-hitokoto');
                this.hitokotoText = $('.mfunsPlayer-loading-hitokoto-text');
                this.hitokotoFrom = $('.mfunsPlayer-loading-hitokoto-from');
                this.pip_btn = $('.mfunsPlayer-controller-pip');
                this.playerTip = $('.mfunsPlayer-tip-container');
                this.notice = $('.mfunsPlayer-notice');
                this.noticeText = $('.mfunsPlayer-notice-text');
                this.noticeTodo = $('.mfunsPlayer-notice-todo');
                this.noticeClose = $('.mfunsPlayer-notice-close');
                this.skip = $('.mfunsPlayer-skip');
                this.skipText = $('.mfunsPlayer-skip-text');
                this.skipLink = $('.mfunsPlayer-skip-link');
                this.skipClose = $('.mfunsPlayer-skip-close');
                this.playerLoad = $('.mfunsPlayer-player-load-status');
                this.videoLoad = $('.mfunsPlayer-video-load-status');
                this.danmakuLoad = $('.mfunsPlayer-danmaku-load-status');
                this.loadMask = $('.mfunsPlayer-load-mask');
                this.controllerTime = $('.mfunsPlayer-controller-time');
                this.time_label = $('.mfunsPlayer-controller-time-label');
                this.currentTime = $('.mfunsPlaye-video-currentTime');
                this.totalTime = $('.mfunsPlaye-video-totalTime');
                this.time_input = $('.mfunsPlayer-controller-time-input');
                this.toLogin = $('.mfunsPlayer-toLogin');
                this.danmakuTipMask = $('.mfunsPlayer-danmaku-item-tip-mask');
                this.danmakuTipBox = $('.mfunsPlayer-danmaku-item-tip-box');
                this.danmakuTip = $('.mfunsPlayer-danmaku-item-tip');
                this.danmakuPraise = $('.mfunsPlayer-danmaku-item-tip-praise');
                this.danmakuCancel = $('.mfunsPlayer-danmaku-item-tip-cancel');
                this.danmakuCopy = $('.mfunsPlayer-danmaku-item-tip-copy');
                this.danmakuReport = $('.mfunsPlayer-danmaku-item-tip-report');
                this.danmakuReportMask = $('.mfunsPlayer-danmaku-report-mask');
                this.danmakuReportContent = $('.mfunsPlayer-danmaku-report-content');
                this.danmakuReportModelClose = $('.mfunsPlayer-danmaku-report-close');
                this.danmakuReportDetail = $('.mfunsPlayer-danmaku-report-detail');
                this.danmakuReportSubmit = $('.mfunsPlayer-danmaku-report-submit');
                this.danmakuEmit = $('.mfunsPlayer-danmaku-emit');
                this.danmakuText = $('.mfunsPlayer-danmaku-text');
                this.danmakuStatusLoading = $('.mfunsPlayer-danmaku-status-loading');
                this.danmakuStyle_btn = $('.mfunsPlayer-controller-danmaku-style');
                this.danmaku_fontsize_picker = $('.mfunsPlayer-danmaku-fontsize-picker');
                this.danmaku_mode_picker = $('.mfunsPlayer-danmaku-mode-picker');
                this.danmaku_color_input = $('.mfunsPlayer-danmaku-color-input');
                this.danmaku_color_preview = $('.mfunsPlayer-danmaku-color-preview');
                this.danmaku_color_picker = $('.mfunsPlayer-danmaku-color-picker');
                this.danmaku_catch_switch = $('.mfunsPlayer-danmaku-catch-switch');
                this.danmaku_highEnergy_switch = $('.mfunsPlayer-danmaku-highEnergy-switch');
                this.danmaku_keep_out_subtitle_switch = $('.mfunsPlayer-danmaku-keep-out-subtitle');
                this.infoPanel = $('.mfunsPlayer-info-panel');
                this.infoPanelClose = $('.mfunsPlayer-info-panel-close');
                this.infoVersion = $('.mfunsPlayer-info-panel-item-version .mfunsPlayer-info-panel-item-data');
                this.infoFPS = $('.mfunsPlayer-info-panel-item-fps .mfunsPlayer-info-panel-item-data');
                this.infoType = $('.mfunsPlayer-info-panel-item-type .mfunsPlayer-info-panel-item-data');
                this.infoUrl = $('.mfunsPlayer-info-panel-item-url .mfunsPlayer-info-panel-item-data');
                this.infoResolution = $('.mfunsPlayer-info-panel-item-resolution .mfunsPlayer-info-panel-item-data');
                this.infoDuration = $('.mfunsPlayer-info-panel-item-duration .mfunsPlayer-info-panel-item-data');
                this.infoDanmakuId = $('.mfunsPlayer-info-panel-item-danmaku-id .mfunsPlayer-info-panel-item-data');
                this.infoDanmakuApi = $('.mfunsPlayer-info-panel-item-danmaku-api .mfunsPlayer-info-panel-item-data');
                this.infoDanmakuAmount = $('.mfunsPlayer-info-panel-item-danmaku-amount .mfunsPlayer-info-panel-item-data');
                this.hotkeyPanel = $('.mfunsPlayer-hotkey-panel');
                this.hotkeyPanelClose = $('.mfunsPlayer-hotkey-panel-close');
                this.voice = $('.mfunsPlayer-voice');
                this.voiceValue = $('.mfunsPlayer-voice-value');
            }
        },
        {
            key: 'initHitokoto',
            value: function initHitokoto(options) {
                var _this = this;
                this.hitokotoText.innerHTML = 'loading...';
                this.hitokotoFrom.innerHTML = '';
                options.apiBackend.read({
                    url: 'https://v1.hitokoto.cn?c=a&c=b&c=c',
                    success: function success(res) {
                        var _res$from_who;
                        _this.hitokotoText.innerHTML = res.hitokoto;
                        _this.hitokotoFrom.innerHTML = '\u2014\u2014\u2014\u2014 \u300C'.concat(res.from, '\u300D').concat((_res$from_who = res.from_who) !== null && _res$from_who !== void 0 ? _res$from_who : '');
                    },
                    error: function error(err) {
                        console.error(err);
                    }
                });
            }
        },
        {
            key: 'buildSmallWindow',
            value: function buildSmallWindow() {
            }
        },
        {
            key: 'buildVideo',
            value: function buildVideo(hasBlackborder) {
                if (!hasBlackborder) {
                    this.videoMask.classList.remove('border');
                    this.bezel.classList.add('noborder');
                } else {
                    this.videoMask.classList.add('border');
                    this.bezel.classList.remove('noborder');
                }
                !this.options.danmaku && this.container.classList.add('noDanmaku');
                var viewHeight = (this.container.clientWidth * 9 / 16 + (hasBlackborder ? 90 : 0)).toFixed(2);
                this.container.style.height = viewHeight + 'px';
                this.player.events.trigger('mounted');
            }
        }
    ]);
    return Template;
}();
export default Template;